/* @flow */
import apiRequest from 'lib/apiRequest';
import Avatar from 'entities/Avatar';
import Collection from 'lib/Collection';

export default class GroupAvatars extends Collection<Avatar> {
  parse(response: Object) {
    return response.map(avatar => Avatar.fromJSON(avatar));
  }

  getRandomAvatar() {
    return this.at(parseInt(Math.random() * this.length, 10));
  }

  // $FlowFixMe
  static fetch(groupName: ?string = null): Promise<GroupAvatars> {
    const data = {};
    if (groupName) {
      data.q = groupName;
    }

    return apiRequest('/classes/avatars', 'GET', data).then(response =>
      GroupAvatars.fromJSON(response)
    );
  }
}
